import styled from 'styled-components';

export const Arrow = styled('img')<{ active: boolean }>`
  margin: 0 0 0 6px;
  width: 10px;
  height: 6px;
  transition: transform 0.5s ease-out;
  transform: ${({ active }) => (active ? 'scaleY(1)' : 'scaleY(-1)')};
`;

export const StyledCollapseDetailsButton = styled.div`
  display: flex;
  align-items: center;
  font-family: ${(props) =>
    props.theme.atlas.typography.semantic.bodySmall.fontFamily};
  font-size: 14px;
  font-weight: 500;
  color: ${(props) => props.theme.atlas.semantic.color.type.muted};

  cursor: pointer;
`;
